/* mBr cart: shows the live average of approved reviews in the cart page and cart drawer */
(() => {
  if (window.mbrCartRating) return;
  window.mbrCartRating = true;

  const KEY = 'mbrCartRating:v1';
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const LOCK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5Zm-3 8V7a3 3 0 0 1 6 0v3H9Z"/></svg>';
  const ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M19 12H5m6-6-6 6 6 6"/></svg>';
  let ratingPromise;

  const readCache = () => {
    try { const v = JSON.parse(sessionStorage.getItem(KEY)); return v && v.avg ? v : null; } catch (e) { return null; }
  };

  const fetchRating = async () => {
    const cached = readCache();
    if (cached) return cached;
    try {
      const res = await fetch(ROOT + '?section_id=mbr-approved-reviews', { credentials: 'same-origin' });
      if (!res.ok) return null;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const avg = parseFloat(doc.querySelector('.eo-rv__big')?.textContent || '');
      const match = (doc.querySelector('.eo-rv__sum')?.textContent || '').match(/Based on\s+(\d+)/);
      if (!avg || !match) return null;
      const value = { avg: Math.round(avg * 10) / 10, count: parseInt(match[1], 10) };
      try { sessionStorage.setItem(KEY, JSON.stringify(value)); } catch (e) {}
      return value;
    } catch (e) {
      return null;
    }
  };

  const ratingHtml = (v) => {
    const pct = Math.max(0, Math.min(100, (v.avg / 5) * 100));
    const label = v.count === 1 ? 'review' : 'reviews';
    return '<a class="mbr-rate__link" href="' + ROOT + 'pages/product-reviews">' +
      '<span class="mbr-rate__stars" style="--fill:' + pct + '%" role="img" aria-label="Rated ' + v.avg.toFixed(1) + ' out of 5">★★★★★</span>' +
      '<span class="mbr-rate__num">' + v.avg.toFixed(1) + ' / 5</span></a>' +
      '<span class="mbr-rate__note">Based on ' + v.count + ' customer ' + label + '</span>';
  };

  const addContinueLink = () => {
    if (!document.body.classList.contains('template-cart')) return;
    const items = document.querySelector('#main-cart-items');
    if (!items || document.querySelector('.mbr-continue')) return;
    const original = document.querySelector('.title-wrapper-with-link .underlined-link');
    const link = document.createElement('a');
    link.className = 'mbr-continue';
    link.href = original ? original.getAttribute('href') : ROOT + 'collections/all';
    link.innerHTML = ARROW + '<span>Continue shopping</span>';
    items.insertAdjacentElement('afterend', link);
    document.body.classList.add('mbr-has-continue');
  };

  const render = async () => {
    addContinueLink();
    const footer = document.querySelector('cart-drawer .drawer__footer');
    if (footer && !footer.querySelector('.mbr-secure')) {
      const secure = document.createElement('p');
      secure.className = 'mbr-secure';
      secure.innerHTML = LOCK + '<span>Secure checkout</span>';
      footer.appendChild(secure);
    }
    ratingPromise = ratingPromise || fetchRating();
    const v = await ratingPromise;
    if (!v) return;
    document.querySelectorAll('[data-mbr-cart-rating]').forEach((el) => {
      if (el.dataset.mbrDone) return;
      el.innerHTML = ratingHtml(v);
      el.hidden = false;
      el.dataset.mbrDone = '1';
    });
    const drawerFooter = document.querySelector('cart-drawer .drawer__footer');
    if (drawerFooter && !drawerFooter.querySelector('.mbr-rate')) {
      const box = document.createElement('div');
      box.className = 'mbr-rate mbr-rate--drawer';
      box.innerHTML = ratingHtml(v);
      drawerFooter.insertBefore(box, drawerFooter.querySelector('.cart__ctas') || drawerFooter.querySelector('.mbr-secure'));
    }
  };

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; render(); });
  };

  const start = () => {
    render();
    const drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    const main = document.getElementById('MainContent');
    if (main && document.body.classList.contains('template-cart')) new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
